import { h, Component } from 'preact'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import R from 'ramda'
import { Element, scroller } from 'react-scroll'

import * as actions from '../actions'
import {
  JobType, CompanyType, ImageType, PaginationType, JobsFilterType, CategoryType
} from '../reducers'
import JobTile from '../components/JobTile'
import Pagination from '../components/Pagination'
import { jobsPlacesIds } from '../helpers/jobs'
import { getMediaItemById } from '../reducers/mediaItems'
import { media } from '../styled/mixins'
import CategorySelectBox from '../components/CategorySelectBox'
import Spinnerable from '../components/Spinnerable'

const JobsContent = styled(Element)``

const BlockTitle = styled.div``

const Wrapper = styled.div`
  .inner-content {
    font-family: 'Lato', sans-serif;
    background: #fff;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    text-align: left;
    padding: 20px;
    ${BlockTitle} {
      color: #B3BFC4;
      font-weight: 300;
      font-size: 24px;
      line-height: 32px;
      ${media.tablet`
        margin-bottom: 16px;
      `}
    }
    ${CategorySelectBox} {
      margin-top: 18px;
    }
    ${JobsContent} {
      margin: 40px 0 32px;
    }
  }
`

const PAGE_SIZE = 10

export const fetchData = (props) => {
  const {
    loadJobs,
    loadCompany,
    loadPlacesIfNeeded,
    loadAssociatedCategoriesIfNeeded,
    loadCompanyLogoIfNeeded,
    companyId
  } = props

  const getJobs = R.composeP(
    R.path(['value', 'items']),
    R.compose(
      R.partialRight(loadJobs, [{
        pageSize: PAGE_SIZE
      }]),
      R.prop('id'),
    )
  )

  const jobsWithLocationsRequest = R.composeP(
    loadPlacesIfNeeded,
    jobsPlacesIds,
    getJobs
  )

  const companyLogoRequest = R.compose(
    loadCompanyLogoIfNeeded,
    R.prop('logoId')
  )

  const associatedCategoriesRequest = R.compose(
    loadAssociatedCategoriesIfNeeded,
    R.prop('id')
  )

  return R.composeP(
    requests => Promise.all(requests),
    R.juxt([
      jobsWithLocationsRequest,
      companyLogoRequest,
      associatedCategoriesRequest
    ]),
    R.prop('value'),
    loadCompany
  )(companyId)
}

class Main extends Component {
  propTypes = {
    loadJobs: PropTypes.func.isRequired,
    companyId: PropTypes.number.isRequired,
    jobs: PropTypes.arrayOf(JobType),
    categories: PropTypes.arrayOf(CategoryType).isRequired,
    company: CompanyType.isRequired,
    companyLogo: ImageType,
    places: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    pagination: PaginationType.isRequired,
    filters: JobsFilterType.isRequired,
    isLoading: PropTypes.bool.isRequired
  }

  defaultProps = {
    companyLogo: null,
    places: {}
  }

  componentWillMount() {
    fetchData(this.props)
  }

  handlePagination = (data) => {
    const { loadJobs, companyId, filters } = this.props

    loadJobs(companyId, {
      page: data.page,
      pageSize: PAGE_SIZE,
      filters
    }).then(() => {
      scroller.scrollTo('jobsContent', {
        duration: 300,
        delay: 50,
        smooth: 'easeInOutQuint',
        offset: -100
      })
    })
  }

  handleSelectCategory = (categoryId) => {
    const { loadJobs, companyId } = this.props

    loadJobs(companyId, categoryId ? { filters: { categoryId }, pageSize: PAGE_SIZE } : null)
  }

  render() {
    const {
      jobs, company, companyLogo, places, categories, pagination, filters, isLoading
    } = this.props
    return (
      <Wrapper>
        <Spinnerable items={jobs} isLoading={isLoading} className="inner-content">
          {jobs.length > 0 ? (
            <div>
              <CategorySelectBox
                value={R.propOr('', 'categoryId')(filters)}
                onChange={this.handleSelectCategory}
                categories={categories}
              />
              <JobsContent name="jobsContent">
                {jobs.map(job => (
                  <JobTile
                    key={job.id}
                    job={job}
                    logo={companyLogo}
                    company={company}
                    place={places[job.placeId]}
                  />
                ))}
              </JobsContent>
              {pagination && <Pagination
                pagination={pagination}
                onPagination={this.handlePagination}
              />}
            </div>
          ) : (
            <BlockTitle>
              No active jobs
            </BlockTitle>
          )}
        </Spinnerable>
      </Wrapper>
    )
  }
}

const mapStateToProps = ({ company, jobs, places, categories, ...rest }) => ({
  company,
  jobs: jobs.items,
  filters: jobs.filters,
  pagination: jobs.pagination,
  isLoading: jobs.isLoading,
  companyLogo: company && getMediaItemById(rest, company.logoId),
  places: places.items,
  categories
})

export default connect(mapStateToProps, actions)(Main)



// WEBPACK FOOTER //
// ./src/containers/Main.js